import React from 'react'
import { Flex, Grid } from '@fareye/ui'
import { Header } from '@fareye/common'
import { currenthhmmA } from '@fareye/utils'
import {
  IModuleRenderingConfig,
  TValidConfigId,
  TChildUserConfigs
} from '../../../utility/types'
import { ChildUserFeatureListing } from '../components/ChildUserFeaturesListing'
import { ChildUserListing } from './ChildUser/ChildUserListing'
import { FilterListing } from './Filter/FilterListing'
export function ChildUserFilter({
  match,
  location,
  history,
  routesConfig,
  config
}: IModuleRenderingConfig) {
  const [lastUpdate, setLastUpdate] = React.useState(currenthhmmA())
  const [selectedFeature, setSelectedFeature] = React.useState<TValidConfigId>(
    'listChildUser'
  )
  const { children: featureConfig, baseUrl } = config
  const { styling } = (featureConfig as any)[selectedFeature]
  function renderOnFeatureType() {
    switch (selectedFeature) {
      case 'listChildUser':
        return (
          <ChildUserListing
            baseUrl={baseUrl}
            {...(featureConfig as any)[selectedFeature]}
          />
        )
      case 'listChildFilter':
        return <FilterListing {...(featureConfig as any)[selectedFeature]} />
      default:
        featureConfig
        return (
          <ChildUserListing
            baseUrl={baseUrl}
            {...(featureConfig as any)[selectedFeature]}
          />
        )
    }
  }
  return (
    <Flex column width={1} style={{ height: '100%' }}>
      <Header
        lastUpdate={lastUpdate}
        match={match}
        location={location}
        history={history}
        routesConfig={routesConfig}
      />
      <Grid
        gridTemplateColumns={'200px auto'}
        style={{
          height: '100%',
          overflow: 'hidden',
          padding: 10,
          boxSizing: 'border-box',
          gridGap: '0.625em'
        }}
        bg={styling.bodyBgColor}
      >
        <ChildUserFeatureListing
          featureConfig={featureConfig as TChildUserConfigs}
          selectedFeatureType={selectedFeature}
          setSelectedFeatureType={setSelectedFeature}
        />
        {renderOnFeatureType()}
      </Grid>
    </Flex>
  )
}
